<template>
  <div :class="containerClasses">
    <label
      v-if="label"
      :for="uniqid"
      class="Form-input__label"
    >
      {{ label }}
    </label>
    <textarea
      :id="uniqid"
      :value="value"
      :placeholder="placeholder"
      :class="{ 'resizable': resizable, 'extra-height': extraHeight }"
      :readonly="disabled"
      :remainingCount="remainingCount"
      @input="updateValue($event.target.value)"
      @change="changeValue($event.target.value)"
      @blur="blur"
      @mousedown="startResizing"
    >
    </textarea>
    <p v-if="remainingCount" class="counter">
      {{ remainingCount }} tecken kvar
    </p>
    <p v-if="errorMessage" class="Form-input__error">
      {{ errorMessage }}
    </p>
  </div>
</template>

<script>
import formInputMixin from './form-input-mixin'

export default {
  name: 'TextAreaInput',
  mixins: [formInputMixin],
  data () {
    return {
      interval: null
    }
  },
  props: {
    value: {
      type: [String]
    },
    placeholder: {
      type: String
    },
    resizable: {
      type: Boolean,
      default: false
    },
    extraHeight: {
      type: Boolean,
      default: false
    },
    remainingCount: {
      type: Number
    }
  },
  methods: {
    updateValue: function (value) {
      this.$emit('input', value)
    },
    changeValue: function (value) {
      this.$emit('change', value)
    },
    blur: function () {
      this.$emit('blur')
    },
    startResizing: function (e) {
      window.addEventListener('mouseup', this.stopResizing)
      this.interval = setInterval(() => this.$emit('resize'), 1000 / 15)
    },
    stopResizing: function () {
      clearInterval(this.interval)
      this.removeListener()
    },
    destroyed: function () {
      this.removeListener()
    },
    removeListener: function () {
      this.$emit('resizedone')
      window.removeEventListener('mouseup', this.stopResizing)
    }
  }
}
</script>
